import axios from "axios";
import { apiUrl, imagePath } from "./httpvariables";
import { decryptor, encryptor } from "../../../helpers/hasher.helper";
class HttpService {

    post = async (url, data, headers) => {
        try {
            const encryptedData = encryptor(data)
            const response = await axios.post(`${apiUrl}/${url}`, encryptedData, {
                headers: headers
            });
            const decryptedData = decryptor(response.data.data)
            response.data = decryptedData;
            return response
        } catch (error) {
            const decryptedData = decryptor(error.response.data.data)
            error.response.data = decryptedData;
            return error
        }
    }

    postFormData = async (url, data, headers) => {
        try {
            const response = await axios.post(`${apiUrl}/${url}`, data, {
                headers: headers
            });
            const decryptedData = decryptor(response.data.data)
            response.data = decryptedData;
            return response;
        } catch (error) {
           const decryptedData = decryptor(error.response.data.data)
            error.response.data = decryptedData;
            return error
        }
    }

    get = async (url, headers) => {
        try {
            const response = await axios.get(`${apiUrl}/${url}`, {
                headers: headers
            });
            const decryptedData = decryptor(response.data.data)
            response.data = decryptedData;
            return response;
        } catch (error) {
            const decryptedData = decryptor(error.response.data.data)
            error.response.data = decryptedData;
            return error
        }
    }

    delete = async (url, headers) => {
        try {
            return await axios({
                method: "DELETE",
                url: `${apiUrl}/${url}`,
                headers: headers
            });
        } catch (error) {
            const decryptedData = decryptor(error.response.data.data)
            error.response.data = decryptedData;
            return error
        }
    }

    postFetch = async (data, headers) => {
        try {
            return await fetch(imagePath, {
                method: "POST",
                url: imagePath,
                headers: headers,
                body: data
            });
        } catch (error) {
            const decryptedData = decryptor(error.response.data.data)
            error.response.data = decryptedData;
            return error
        }
    }
}

export default new HttpService();